<template>
    <div :style="style">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'center'
        }
    },
    computed: {
        style() {
            return {
                display: 'flex',
                flexDirection: 'column'
            }
        }
    }
}
</script>